import { ZonedDate } from '@progress/kendo-date-math';

import '@progress/kendo-date-math/tz/US/Eastern';
import '@progress/kendo-date-math/tz/America/New_York';

import '@progress/kendo-date-math/tz/US/Central';
import '@progress/kendo-date-math/tz/America/Chicago';

import '@progress/kendo-date-math/tz/US/Mountain';
import '@progress/kendo-date-math/tz/America/Denver';

import '@progress/kendo-date-math/tz/US/Pacific';
import '@progress/kendo-date-math/tz/America/Los_Angeles';

const timeZoneMap = new Map<string, string>();
timeZoneMap.set("Eastern Standard Time", "US/Eastern");
timeZoneMap.set("Central Standard Time", "US/Central");
timeZoneMap.set("Mountain Standard Time", "US/Mountain");
timeZoneMap.set("Pacific Standard Time", "US/Pacific");

export const convertUtcToTimeZone = (dateInput: string, timeZone: string): Date | null => {
    if (!dateInput) {
        return null;
    }
    var date = new Date(dateInput);
    var tzDate = ZonedDate.fromLocalDate(date, timeZoneMap.get(timeZone));

    return tzDate.toUTCDate();
};

export const getEndOfDayDate = (date: Date): Date => {
    let endDate = new Date(date);
    endDate.setHours(23, 59, 59);
    return endDate;
};

export const DateFormatter =
    new Intl.DateTimeFormat("en-US");